import { deleteCorporateLicence, deleteLicenceDetail } from "@/api/bid";
import { setAllLicenseInfo } from "@/bidFeature/propertyDetailSlice";
import React, { useState } from "react";
import { Table, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "./custom/ConfirmationModel";
import { trackButtonClick } from "@/utils/analytics";
// import { FaEdit, FaTrash } from 'react-icons/fa';

const CorporateInformationTable = ({
  setShow,
  addLicenseInfo,
  onEdit,
  handleShow,
  show,
}) => {
  const dispatch = useDispatch();
  const coroporateInfoSelector = useSelector(
    (state) => state?.propertyDetail?.getAllLicenseInfo?.response
  );
   const [showConfirmModal,setShowConfirmModal] = useState(false)
   const [id,setId] = useState("")

  const handleDelete = async (id) => {
    // Show confirmation dialog first
    setId(id)
    setShowConfirmModal(true)

    trackButtonClick({
      eventName: "bid_license_delete_click",
      eventCategory: "Profile-Forms Bid/Offer wizard",
      eventLabel: `${id} | Corp`,
      eventSource: "on delete license button click",
      eventParams: { license_id: id, license_type: "corp", license_scope: "corporate" },
    })


  };
  // console.log(corporateTableInfoData);
 const handleDeleteLicense=async()=>{
     try {
      // const updatedLicenses = licenceInfoSelector?.INDV?.filter(
      //   (license) => license.licenseId !== id
      // );
       dispatch(
        setAllLicenseInfo({
          response: {
            CORP:
              coroporateInfoSelector?.CORP?.filter(
                (license) => license.licenseId !== id
              ) || [],
            INDV: coroporateInfoSelector?.INDV || [],
          },
        })
      );

      const response = await deleteCorporateLicence(id);
      if(response?.data?.status==="SUCCESS"){
        setShowConfirmModal(false);
        trackButtonClick({
          eventName: "bid_license_delete_click_success",
          eventCategory: "Profile-Forms Bid/Offer wizard",
          eventLabel: `${id}|Corp`,
          eventSource: "on delete license button click success",
          eventParams: { license_id: id, license_type: "corp", license_scope: "corporate" },
        })
      }
    } catch (error) {
      console.error("Error deleting licence:", error);

    }
  }
  const handleCloseDelete = () =>{
    setShowConfirmModal(false)
  }
  return (
    <div className="table-responsive">
      <Table responsive="sm">
        <thead  className="bid-license">
          <tr className="licenseSubHead">
            <th className="bid-license p-3">License Number</th>
            <th className="bid-license p-3">State</th>
            <th className="bid-license p-3">Expiry Date</th>
            <th className="bid-license p-3">Licensed State Office Address</th>
            <th className="bid-license p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {coroporateInfoSelector?.CORP &&
          coroporateInfoSelector?.CORP.length > 0 ? (
            coroporateInfoSelector?.CORP?.map((item, index) => (
              <>
                {/* {console.log(item)}\ */}
                <tr key={index}>
                  <td className="bid-license-number py-3">{item.licenseNumber}</td>
                  <td className="bid-license-number py-3">{item.stateId}</td>
                  <td className="bid-license-number py-3">{item.expiryDate}</td>
                  <td className="bid-license-number py-3">
                    <span className="px-3">{item.company}</span>
                    {item?.address1}{" "}{item.address2}{" "}{item.city && <> , {item.city}</>}{" "}{item.state && <> , {item.state}</>}{" "} {item.zip}
                    </td>

                  <td>
                    {/* <Button
                      variant="link"
                      onClick={() => onEdit(item?.licenseId)}
                    > */}
                      <span className="fa fa-pencil cursor-pointer px-3" onClick={() => onEdit(item?.licenseId)}/>
                    {/* </Button>
                    <Button
                      variant="link"
                      onClick={() => handleDelete(item?.licenseId)}
                    > */}
                      <span className="fa fa-trash cursor-pointer" onClick={() => handleDelete(item?.licenseId)}/>
                    {/* </Button> */}
                  </td>
                </tr>
              </>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                {/* please refresh the page to see licence information available */}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
       <ConfirmationModal
      isOpen={showConfirmModal}
                            onClose={handleCloseDelete}
                            onConfirm={handleDeleteLicense}
                            message={"Are you sure to delete the license"}
                            title="Delete License"/>
    </div>
  );
};

export default CorporateInformationTable;
